import React, { memo } from "react";
import Typographys from "components/Typographys";
import theme from "theme";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";

const InformationItem = props => {
	const classes = useStyles();
	const { icon, title, value, isBorder } = props;

	return (
		<Grid
			item
			xs={6}
			style={{
				borderLeft: isBorder
					? `1px solid ${theme.palette.grey[800]}`
					: "",
				paddingLeft: isBorder ? 10 : 0
			}}
		>
			<Grid container alignItems="center">
				<Grid classes={{ root: classes.icon }}>{icon}</Grid>
				<Grid>
					<Typographys className={classes.title}>{title}</Typographys>
					<Typographys className={classes.value}>{value}</Typographys>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(InformationItem);
